/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsRightLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m20 17-5-5 5-5" }],
    ["path", { d: "m4 17 5-5-5-5" }]
  ]
];

export { ChevronsRightLeft as default };
//# sourceMappingURL=chevrons-right-left.js.map
